module.exports = __webpack_public_path__ + "static/img/heungkukfire-direct-car.bde69fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/heungkukfire-direct-car.jpg
// module id = 8Gt4
// module chunks = 0